import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Nav extends PureComponent {
    
    static propTypes = {
        content: PropTypes.object
    };
    
    render() {
        
        const { content } = this.props;
        const { first, second, third } = content;
        const arr = [ first, second, third ];

        return (
            <div className={styles.navWp}>
                <div className={styles.navInner}>
                    <a href="https://news.ifeng.com" target="_blank" rel="noreferrer">
                        <img className={styles.logo} src="https://x0.ifengimg.com/cmpp/2020/0508/logo.png" alt="logo" />
                    </a>
                    <div className={styles.navList}>
                        {
                            arr.map((item, index) => {
                                return (
                                    <div className={styles.nav} key={index}>
                                        <div className={styles.title}>
                                            {item.title}
                                        </div>
                                        <div>
                                            <div className={styles.subTitle}>
                                                {
                                                    item.subTitle && item.subTitle.filter((a, b) => b % 2 === 0).map((a, i) => {
                                                        return <a key={i} href={a.url} target="_blank" rel="noreferrer">{a.name}</a>;
                                                    })
                                                }
                                            </div>
                                            <div className={styles.subTitle}>
                                                {
                                                    item.subTitle && item.subTitle.filter((a, b) => b % 2 !== 0).map((a, i) => {
                                                        return <a key={i} href={a.url} target="_blank" rel="noreferrer">{a.name}</a>;
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );

    }
}

export default Nav;
